export var CommonPagePathsEnum;

(function (CommonPagePathsEnum) {
  /** System admin */
  CommonPagePathsEnum["Import"] = "SYSTEM-ADMIN-IMPORT-PATH";
})(CommonPagePathsEnum || (CommonPagePathsEnum = {}));